// src/pages/student/ViewMaterials.jsx
import React, { useEffect, useState } from "react";
const API_URL = process.env.REACT_APP_API_URL;

export default function ViewMaterials() {
  const [materials, setMaterials] = useState([]);
  const [filterTeacher, setFilterTeacher] = useState("all");
  const [teachers, setTeachers] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("user"));
    setUser(currentUser);
    fetchMaterials();
    fetchTeachers();
  }, []);

  const fetchMaterials = async () => {
    try {
      const res = await fetch(`${API_URL}/api/teacher/materials`);
      const data = await res.json();
      setMaterials(data);
        console.log("Fetched materials:", data);
    } catch (err) {
      console.error("Error fetching materials:", err);
    }
  

  };

  const fetchTeachers = async () => {
    try {
      const res = await fetch(`${API_URL}/api/teachers`);
      const data = await res.json();
      setTeachers(data);
    } catch (err) {
      console.error("Error fetching teachers:", err);
    }
  };

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are you sure you want to delete this material?");
    if (!confirm) return;

    try {
      const res = await fetch(`${API_URL}/api/teacher/materials/${id}`, {
        method: "DELETE",
      });
      const data = await res.json();
      alert(data.message);
      fetchMaterials();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const filteredMaterials =
    filterTeacher === "all"
      ? materials
      : materials.filter((mat) => mat.teacher?._id === filterTeacher);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">📁 Teaching Materials</h1>

        <div className="mb-4">
          <label className="font-medium mr-2">Filter by Teacher:</label>
          <select
            value={filterTeacher}
            onChange={(e) => setFilterTeacher(e.target.value)}
            className="border border-gray-300 rounded px-3 py-2"
          >
            <option value="all">All</option>
            {teachers.map((t) => (
              <option key={t._id} value={t._id}>
                {t.name}
              </option>
            ))}
          </select>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {filteredMaterials.map((material) => (
            <div
              key={material._id}
              className="bg-white shadow-md p-5 rounded-lg border"
            >
              <h2 className="text-lg font-semibold text-indigo-800">
                {material.title}
              </h2>
              <p className="text-sm mt-1 text-gray-600">{material.description}</p>
              <p className="text-sm mt-1 text-gray-500">
                By: <strong>{material.teacher?.name || "Unknown"}</strong>
              </p>
              <a
                href={`http://localhost:5000/${material.path}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block mt-3 text-blue-600 hover:underline"
              >
                📄 View File
              </a>
              {user?.role === "teacher" && user._id === material.teacher?._id && (
                <div className="mt-4 flex gap-3">
                  <button
                    onClick={() => handleDelete(material._id)}
                    className="text-sm text-red-600 hover:underline"
                  >
                    ❌ Delete
                  </button>
                  {/* Optionally add an Edit button here */}
                </div>
              )}
            </div>
          ))}
        </div>

        {filteredMaterials.length === 0 && (
          <p className="mt-8 text-gray-500 text-center">No materials found.</p>
        )}
      </div>
    </div>
  );
}
